export default __webpack_public_path__ + "static/media/foster_kinship_1.4fc232d5.jpg";